function isVariant(definition) {
    return typeof definition === "object";
}

export { isVariant };
